import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Sidebar } from "@/components/Sidebar";
import { MessageNotifier } from "@/components/MessageNotifier";
import { ForcedPasswordChangeDialog } from "@/components/ForcedPasswordChangeDialog";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Anmeldungen from "@/pages/Anmeldungen";
import Zaehlertermine from "@/pages/Zaehlertermine";
import Erinnerungen from "@/pages/Erinnerungen";
import Auftraggeber from "@/pages/Auftraggeber";
import EmailInbox from "@/pages/EmailInbox";
import EmailSettings from "@/pages/EmailSettings";
import Projekte from "@/pages/Projekte";
import Projekttermine from "@/pages/Projekttermine";
import Einstellungen from "@/pages/Einstellungen";
import Monteure from "@/pages/Monteure";
import Team from "@/pages/Team";
import Profil from "@/pages/Profil";
import DatenImport from "@/pages/DatenImport";
import Kunden from "@/pages/Kunden";
import Nachrichten from "@/pages/Nachrichten";
import MeinDashboard from "@/pages/MeinDashboard";
import MonteurPortal from "@/pages/MonteurPortal";
import Rechnungen from "@/pages/Rechnungen";
import { useAuth } from "@/context/AuthContext";

function RoleAwareHome() {
  const { user } = useAuth();
  if (user && user.role === "auftraggeber") return <MeinDashboard />;
  if (user && user.role === "sachbearbeiter") return <Anmeldungen />;
  if (user && user.role === "monteur") return <MonteurPortal />;
  return <Dashboard />;
}

function AppShell({ children }) {
  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <MessageNotifier />
      <main className="flex-1 min-w-0 pt-14 lg:pt-0">{children}</main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppShell><RoleAwareHome /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mein-dashboard"
            element={
              <ProtectedRoute>
                <AppShell><MeinDashboard /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/anmeldungen"
            element={
              <ProtectedRoute>
                <AppShell><Anmeldungen /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/auftraggeber"
            element={
              <ProtectedRoute>
                <AppShell><Auftraggeber /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/zaehlertermine"
            element={
              <ProtectedRoute>
                <AppShell><Zaehlertermine /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/erinnerungen"
            element={
              <ProtectedRoute>
                <AppShell><Erinnerungen /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/posteingang"
            element={
              <ProtectedRoute>
                <AppShell><EmailInbox /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-einstellungen"
            element={
              <ProtectedRoute>
                <AppShell><EmailSettings /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/projekte"
            element={
              <ProtectedRoute>
                <AppShell><Projekte /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/projekttermine"
            element={
              <ProtectedRoute>
                <AppShell><Projekttermine /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/einstellungen"
            element={
              <ProtectedRoute>
                <AppShell><Einstellungen /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/monteure"
            element={
              <ProtectedRoute>
                <AppShell><Monteure /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/team"
            element={
              <ProtectedRoute>
                <AppShell><Team /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profil"
            element={
              <ProtectedRoute>
                <AppShell><Profil /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/import"
            element={
              <ProtectedRoute>
                <AppShell><DatenImport /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/kunden"
            element={
              <ProtectedRoute>
                <AppShell><Kunden /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/rechnungen"
            element={
              <ProtectedRoute>
                <AppShell><Rechnungen /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/nachrichten"
            element={
              <ProtectedRoute>
                <AppShell><Nachrichten /></AppShell>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <ForcedPasswordChangeDialog />
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
